export const FETCH_FUND = "/accounting/fund_detail_report/";

export const BASIC_FETCH_FUND = "/accounting/basic_fund_detail_report/";

export const DOWNLOAD_CONTRIBUTION = "/accounting/contribution_report/download/";
